<div class="my-content">
  <div *ngIf="!emailSent" class="top">
    <div class="title" translate="forgot-password.forgot-password"></div>
    <div class="let-us-know" translate="forgot-password.let-us-know"></div>
  </div>
  <div *ngIf="emailSent" class="top">
    <div class="title" translate="forgot-password.you-have-got-mail"></div>
    <div class="let-us-know" translate="forgot-password.email-sent"></div>
  </div>

  <form *ngIf="!emailSent" class="form" (ngSubmit)="onSubmit()" [formGroup]="forgotForm">

    <app-input [parentFormGroup]="forgotForm" [formControl]="forgotForm.get('email')" [placeholder]="'registration.email' | translate">
      <span [class.hidden]="!(forgotEmail.invalid && (forgotEmail.dirty || forgotEmail.touched))" class="glyphicon glyphicon-remove form-control-feedback-error"></span>
      <i class="form-control-feedback material-icons md-18" [class.hidden]="!forgotEmail.value || forgotEmail.value.length === 0" (click)="forgotEmail = ''">highlight_off</i>
    </app-input>

    <button type="submit" class="btn-redesign btn-redesign--primary continue" translate="forgot-password.send" [disabled]="!forgotForm.valid"></button>
    <div class="cancel">
      <a type="button" translate="forgot-password.cancel" (click)="showForgotPassword.emit({show: false, email: forgotEmail.value})"></a>
    </div>
  </form>
</div>
